export default [
  {
    id: 'Call',
    label: 'Call',
    value: 24,
    color: '#b9b8b8',
  },
  {
    id: '1-7 Days',
    label: '1-7 Days',
    value: 16,
    color: '#957bae',
  },
  {
    id: '7-35 Days',
    label: '7-35 Days',
    value: 33,
    color: '#0B8FCF',
  },
  {
    id: '35-95 Days',
    label: '35-95 Days',
    value: 20,
    color: '#144B73',
  },
  {
    id: '95+ Days',
    label: '95+ Days',
    value: 7,
    color: '#A94F74',
  },
];
